var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "Footer_icon__2SJEw",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.95a10 10 0 0120 0v1.43a3.51 3.51 0 01-3.5 3.57 3.7 3.7 0 01-2.96-1.47A5 5 0 1117 11.95v1.43c0 .79.71 1.57 1.5 1.57s1.5-.78 1.5-1.57v-1.43c0-4.34-3.66-8-8-8a8.1 8.1 0 00-8 8c0 4.34 3.66 8 8 8h5v2h-5a10 10 0 01-10-10zm7 0a3 3 0 106 0 3 3 0 00-6 0z",
    fill: "#db2b27"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconEmail);
export default __webpack_public_path__ + "static/media/footer-icon-email.8cc5dfb1bdf3d7bf2aac2d9234f8cb60.svg";
export { ForwardRef as ReactComponent };